import { apiFetchWithRetry } from "../lib/request";

export function loadSupportStatus() {
  return apiFetchWithRetry("/users/support/status", { method: "GET" });
}

export function listSupportAccounts(query = "") {
  return apiFetchWithRetry(`/users/support/accounts?query=${encodeURIComponent(query)}`, { method: "GET" });
}

export function startSupportAccess(accountId) {
  return apiFetchWithRetry("/users/support/start", {
    method: "POST",
    body: JSON.stringify({ accountId })
  });
}

export function endSupportAccess(accountId) {
  return apiFetchWithRetry("/users/support/end", {
    method: "POST",
    body: JSON.stringify({ accountId })
  });
}
